import { Link } from "react-router-dom";

export interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.label,
      item: item.path
        ? `${window.location.origin}${item.path}`
        : undefined,
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm">
        {items.map((item, index) => (
          <span key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
            )}
            {item.path && index < items.length - 1 ? (
              <Link
                to={item.path}
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-300 whitespace-nowrap">
                {item.label}
              </span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}